import { Component, Vue, Prop } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import merge from 'lodash/merge'
import { AxiosResponse } from 'axios'
import { BFormGroup, BFormRow, BCol } from 'bootstrap-vue'
import { KForm, KFormInput, KFormDatetime, KFormSelect, KFormEditor } from '@kwixeo/form-vue'
import { emitter, TeamUserSelect } from '@kwixeo/interface-vue'
import TaskElementSearch from '../TaskElementSearch/TaskElementSearch.vue'

@Component({
  computed: {
    ...mapGetters('user', ['teamUserConfigs']),
    ...mapGetters('tasks', ['defaultCategory', 'activeCategories'])
  },
  methods: {
    ...mapActions('tasks', ['loadCategories'])
  },
  components: {
    TeamUserSelect,
    TaskElementSearch,
    KForm, KFormInput, KFormDatetime, KFormSelect, KFormEditor,
    BFormGroup, BFormRow, BCol
  }
})
export default class TaskForm extends Vue {
  activeCategories!: KwixeoTasks.Categories
  defaultCategory!: KwixeoTasks.Category
  loadCategories!: (force?: boolean) => void
  teamUserConfigs!: KwixeoInterface.GenericObject

  @Prop({ default: null }) value!: KwixeoTasks.Task|null

  private task: KwixeoTasks.TaskForm = {
    datetime: null,
    elements: [],
    team_users: []
  }

  async created (): Promise<void> {
    await this.loadCategories()

    if (this.value && this.value.id) {
      this.setLocalValue(this.value)
    } else {
      this.setDefaultValue()
    }
  }

  get priorities (): KwixeoTasks.Priority[] {
    return [
      { value: 1, label: this.$t('tasks.priorities.1') },
      { value: 2, label: this.$t('tasks.priorities.2') },
      { value: 3, label: this.$t('tasks.priorities.3') }
    ]
  }

  get status (): KwixeoTasks.Status[] {
    return [
      { value: 1, label: this.$t('tasks.status.1') },
      { value: 2, label: this.$t('tasks.status.2') },
      { value: 3, label: this.$t('tasks.status.3') },
      { value: 4, label: this.$t('tasks.status.4') }
    ]
  }

  get formUrl (): string {
    let url = '/task'
    if (this.task.id) {
      url += '/' + this.task.id
    }
    return url + '?with_file=true'
  }

  get formMethod (): string {
    return this.task.id ? 'PUT' : 'POST'
  }

  get computedDatetime (): string|null|undefined {
    let datetime = this.task.datetime
    if (datetime && datetime.length === 10) {
      datetime += ' 00:00:00'
    }
    return datetime
  }

  private setDefaultValue (): void {
    const date = moment()
    if (this.teamUserConfigs.task_defaut_date > 0) {
      date.add(this.teamUserConfigs.task_defaut_date, 'days')
    }

    this.task = merge(
      {
        elements: [],
        datetime: date.format('YYYY-MM-DD'),
        status: this.status[0],
        priority: this.priorities[1],
        team_users: this.teamUserConfigs.task_defaut_team_user,
        category: this.defaultCategory
      },
      this.value ? JSON.parse(JSON.stringify(this.value)) : {}
    )
  }

  private setLocalValue (task: KwixeoTasks.Task): void {
    this.task = JSON.parse(JSON.stringify(task))

    if (this.task.datetime) {
      this.task.datetime = moment(this.task.datetime).format('YYYY-MM-DD HH:mm:ss')
    }

    if (!this.task.category) {
      this.task.category = { id: 0, label: this.$t('tasks.other'), status: { active: true, name: '' } }
    }
  }

  private submitComplete (response: AxiosResponse): void {
    const task = response.data
    if (this.value && this.value.id) {
      emitter.emit('taskUpdated', {
        old: this.value,
        new: task
      })
    } else {
      emitter.emit('taskCreated', task)
    }
    this.$emit('input', response.data)
  }
}
